import sentry from 'legacy/utils/sentry'

import { type PreferredLane, getEquipmentTypes } from '../domain/PreferredLane'
import { SuggestedPreferredLaneAction } from '../domain/SuggestedPreferredLane'
import { type LaneHistoryRepository } from '../infra/LaneHistoryRepository'
import { type PreferredLaneRepository } from '../infra/PreferredLaneRepository'
import { type SuggestedPreferredLaneRepository } from '../infra/SuggestedPreferredLaneRepository'
import { addSearchToLaneHistoryFactory } from './addSearchToLaneHistory'
import { getSuggestedPreferredLanesFactory } from './getSuggestedPreferredLanes'
import { shouldSuggestPreferredLaneOnSearchFactory } from './shouldSuggestPreferredLaneOnSearch'
import { suggestPreferredLaneFactory } from './suggestPreferredLane'

export type TrackLaneSearchDependencies = {
  laneHistoryRepository: LaneHistoryRepository
  preferredLaneRepository: PreferredLaneRepository
  suggestedPreferredLaneRepository: SuggestedPreferredLaneRepository
}

export function trackLaneSearchFactory({
  laneHistoryRepository,
  suggestedPreferredLaneRepository,
  preferredLaneRepository,
}: TrackLaneSearchDependencies) {
  const addSearchToLaneHistory = addSearchToLaneHistoryFactory({
    laneHistoryRepository,
  })
  const getSuggestedPreferredLanes = getSuggestedPreferredLanesFactory({
    suggestedPreferredLaneRepository,
  })
  const shouldSuggestPreferredLaneOnSearch = shouldSuggestPreferredLaneOnSearchFactory({
    laneHistoryRepository,
    preferredLaneRepository,
    suggestedPreferredLaneRepository,
  })
  const suggestPreferredLane = suggestPreferredLaneFactory({
    laneHistoryRepository,
    suggestedPreferredLaneRepository,
  })

  return async function trackLaneSearch(preferredLane: PreferredLane) {
    try {
      preferredLane.equipmentTypes = getEquipmentTypes(preferredLane)

      await addSearchToLaneHistory(preferredLane)

      if (await shouldSuggestPreferredLaneOnSearch(preferredLane)) {
        await suggestPreferredLane(preferredLane, SuggestedPreferredLaneAction.Search)
      }
    } catch (error) {
      sentry.log(error)
    }

    try {
      return getSuggestedPreferredLanes()
    } catch (error) {
      sentry.log(error)
      return []
    }
  }
}
